import { Manager } from '@wework/floormap-sdk'

const createManager = configuration => {
  return new Manager(configuration)
}

export default createManager
